export interface ApiErrorBody {
  statusCode?: number;
  code?: string;
  message?: string;
  details?: unknown;
}

export class ApiError extends Error {
  readonly status: number;
  readonly body: ApiErrorBody | undefined;

  constructor(status: number, message: string, body?: ApiErrorBody) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

export class AuthError extends ApiError {
  constructor(message: string, body?: ApiErrorBody) {
    super(401, message, body);
    this.name = 'AuthError';
  }
}

export class ApiResponseValidationError extends Error {
  readonly issues: unknown;

  constructor(message: string, issues: unknown) {
    super(message);
    this.name = 'ApiResponseValidationError';
    this.issues = issues;
  }
}
